<template>
  <div class="ImportWizard" :class="{'android-context': isAndroidContext}">
    <MainPageHeader v-if="!isAndroidContext"/>
    <div class="content">
      <div v-if="!isAndroidContext" class="header">
        <h1 class="font-size-big">Moje piosenki</h1>
      </div>
      <div class="import-wizard-wrapper" v-if="!isLoading">
        <div class="buttons">
          <SmallButton class="cancel-button" @click="cancelWizard" v-if="!isAndroidContext">
            Anuluj
          </SmallButton>
          <SmallButton border-color="primary" @click="saveWizard">
            Zapisz
          </SmallButton>
        </div>
        <div class="page-containers" v-if="!isAndroidContext && windowWidth > 768">
          <div
            v-for="(page, pageIndex) in wizard.files"
            :key="page.id"
            class="page-container"
            :class="{ active: androidContext.currentLyric === pageIndex }">
            <div v-if="page.pages.length > 0 || drag == true" class="page-container-content">
              <div v-if="!isAndroidContext && windowWidth > 768" class="header">
                <DefaultInputField
                  :value="page.name"
                  v-model="page.name"
                  aria-required="true"
                  placeholder="Tytuł piosenki"
                  class="page-title"
                />
              </div>
              <div class="pages">
                <draggable
                  draggable=".preview.desktop"
                  v-model="page.pages"
                  group="files"
                  @start="drag = true"
                  @end="drag = false">
                  <img
                    v-for="p in page.pages"
                    :key="p.id"
                    :class="{ desktop: !isAndroidContext && windowWidth > 768 }"
                    class="preview"
                    :src="p.image" />
                </draggable>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="mobile-containers">
          <div class="mobile-header">
            <span class="hidden-value"></span>
            <DefaultInputField
              :value="wizard.files[androidContext.currentLyric].name"
              ref="mobileTitle"
              v-model="wizard.files[androidContext.currentLyric].name"
              aria-required="true"
              placeholder="Tytuł piosenki"
              class="page-title"
            />
            <font-awesome-icon class="icon" @click="$refs.mobileTitle.focus()" icon="pen" />
          </div>
          <swiper
            :options="swiperOptions"
            ref="mobileSwiper"
            class="mobile-swiper"
            @touchmove="null"
            @touchstart="null"
            @slideChange="onSlideChange">
            <swiper-slide v-for="(page, pageIndex) in wizard.files" :key="pageIndex">
              <div
                class="page-container">
                <div class="single-page" v-for="(p, i) in page.pages" :key="p.id">
                  <font-awesome-icon
                    v-if="i > 0"
                    class="icon remove"
                    @click="undoAddFromAnother(page, i)"
                    icon="times" />
                  <img
                    :class="{ desktop: !isAndroidContext && windowWidth > 768 }"
                    class="preview"
                    :src="p.image" />
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="mobile-bar" v-if="isAndroidContext || windowWidth <= 768">
          <span class="mobile-counter">Strona {{ androidContext.currentLyric + 1 }} z {{ wizard.files.length }}</span>
          <SmallButton
            v-if="(androidContext.currentLyric < wizard.files.length - 1) && (isAndroidContext || windowWidth <= 768)"
            class="last-button"
            @click="addFromAnother">
            Dodaj z kolejnej strony
          </SmallButton>
        </div>
        <SmallButton
          v-if="!isAndroidContext && windowWidth > 768"
          class="last-button"
          border-color="primary"
          @click="saveWizard">
          Zapisz
        </SmallButton>
      </div>
      <div v-else>
        <div class="ph-item" v-if="!isAndroidContext">
          <div class="ph-row buttons">
            <div class="big"></div>
            <div class="big gold"></div>
          </div>
          <div class="ph-col-12 pages">
            <div class="ph-row">
              <div class="big gold"></div>
              <div class="big image"></div>
            </div>
            <div class="ph-row">
              <div class="big gold"></div>
              <div class="big image"></div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="loader-wrapper">
            <div class="loader"></div>
          </div>
        </div>
      </div>
    </div>
    <UpdateLoaderLyric v-if="dataLoading.updatedLoading" :dataLoading="dataLoading" />
    <AndroidImportSuccess v-if="importSuccess" />
  </div>
</template>

<script>
import MainPageHeader from '@/components/MainPageHeader.vue'
import draggable from 'vuedraggable'
import { getAndroidContext } from '@/services/sessionProps'
import SmallButton from '@/components/input/SmallButton.vue'
import UpdateLoaderLyric from '@/components/lyrics/UpdateLoaderLyric.vue'
import { ResizeImage } from '@/services/imageService'
import { toImage, toText } from '@/services/PDFService'
import { getBandLyricsService } from '@/services/bandLyricsService'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import DefaultInputField from '@/components/input/DefaultInputField.vue'
import AndroidImportSuccess from '@/components/AndroidImportSuccess.vue'

import 'swiper/css/swiper.css'

export default {
  name: 'ImportWizard',
  components: {
    MainPageHeader,
    draggable,
    SmallButton,
    UpdateLoaderLyric,
    Swiper,
    SwiperSlide,
    DefaultInputField,
    AndroidImportSuccess
  },
  directives: {
    swiper: directive
  },
  props: ['files'],
  data() {
    return {
      drag: false,
      windowWidth: window.innerWidth,
      isLoading: true,
      importSuccess: false,
      dataLoading: {
        updatedLoading: false,
        loadingName: null,
        loadingOrder: 0,
        numOfFiles: 0,
        files: [],
        filesToLoad: [],
        uploading: false,
        allFiles: [],
      },
      wizard: {
        files: [],
        removedFiles: []
      },
      isAndroidContext: false,
      androidContext: {
        currentLyric: 0,
      },
      swiperOptions: {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 32
      },
      currentlyImportingNumber: 0
    }
  },
  computed: {
    containerElement: function() {
      return document.querySelector('.page-containers');
    },
    swiper: function() {
      return this.$refs.mobileSwiper.$swiper
    }
  },
  mounted() {
    (async () => {
      let fileParam = this.$route.params.files
      if(!fileParam) {
        this.$router.push({ name: 'lyrics-panel' })
      }
      this.isAndroidContext = getAndroidContext().isAndroidContext()
      let files = await this.readFiles(fileParam)
      files.forEach(file => {
        file.forEach((element, index) => {
          let file = {
            name: element.name || 'Tytuł piosenki',
            pages: [element],
            index
          }
          this.wizard.files.push(file)
        })
      })

      const chatRemovalInterval = setInterval(() => {
        let el = document.querySelector('#chat-application')
        if(el !== null) {
          document.querySelector('#chat-application').style.visibility = "hidden"
          clearInterval(chatRemovalInterval)
        }
      }, 200)

      this.$nextTick(() => {
        if(this.isAndroidContext || this.windowWidth <= 768) {
          window.addEventListener('resize', this.onResize)
        }
      })
      this.isLoading = false
    })()
  },
  methods: {
    onSlideChange() {
      this.androidContext.currentLyric = this.swiper.activeIndex
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },

    addFromAnother() {
      let currentFile = this.wizard.files[this.androidContext.currentLyric],
          nextFile = this.wizard.files[this.androidContext.currentLyric + 1]

      if(nextFile !== undefined) {
        currentFile.pages.push(...nextFile.pages)
        this.wizard.removedFiles.push(nextFile)
        this.wizard.files.splice(this.androidContext.currentLyric + 1, 1)
      }
    },

    undoAddFromAnother(currentFile, pageIndex) {
      this.wizard.removedFiles.forEach((removedFile, index) => {
        if(removedFile.pages.includes(currentFile.pages[pageIndex])) {
          this.wizard.files.splice(removedFile.index, 0, removedFile)
          this.wizard.removedFiles.splice(index, 1)
        }
      })

      currentFile.pages.splice(pageIndex, 1)
    },

    cancelWizard() {
      if(confirm('Czy napewno chcesz anulować?')) {
        if(!this.isAndroidContext) {
          this.$router.push({ name: 'lyrics-panel' })
        } else {
          this.$router.push({ name: 'android-lyrics-import' })
        }
        
      }
    },

    async saveWizard() {
      this.wizard.files = this.wizard.files.filter(element => {
        return element.pages.length > 0
      })
      this.startUpload(this.wizard.files.length)
      this.wizard.files.forEach(async element => {
        let mergedImage = await this.mergeImages([element.pages], element.name)
        this.addToQueue(mergedImage)
      })
    },

    readFiles (f) {
      return new Promise(async resolve => {
        const selectedFiles = f,
              promises = []

        const reader = new FileReader()

        for(let i = 0; i < selectedFiles.length; i++) {
          let currentFile = selectedFiles[i],
              loadedFiles = await this.readSingleFile(reader, currentFile)

              promises.push(loadedFiles)
        }

        Promise.all(promises).then((res) => {
          resolve(res)
        })
      })
    },

    readSingleFile(reader, file) {
      return new Promise(resolve => {
        reader.onload = async () => {
          if(file.type == 'application/pdf') {
            let loadedFiles = await this.loadPDF(file)
            
            resolve(loadedFiles)
          } else {
              let image = await ResizeImage(reader.result)
              let fileToUpload = {}
              fileToUpload.name = file.name.split('.').slice(0, -1).join('.')
              fileToUpload.image = image
              resolve([fileToUpload])
            }
        }
        reader.readAsDataURL(file)
      })
    },

    loadPDF(file) {
      return new Promise(resolve => {
        toImage(file).then(async result => {
          let content = await toText(file, 1),
              promises = []
          for(let i = 0; i < result.length; i++) {
            let canvas = result[i]
            let fileToUpload = {}
            if(result.length === 1) {
              fileToUpload.name = file.name.split('.').slice(0, -1).join('.')
            } else {
              fileToUpload.name = content[i].split('\n')[0].replace(' \r', '')
            }
            let contentOnly = content[i].split('\n')
            fileToUpload.content = contentOnly.join('\n')
            fileToUpload.image = canvas

            promises.push(Promise.resolve(fileToUpload))
          }

          Promise.all(promises).then((res) => {
            resolve(res)
          })
        })
      })
    },

    startUpload (num) {
      this.dataLoading.updatedLoading = true
      this.dataLoading.numOfFiles = num;
    },

    async uploadSingleFile(file) {
      let idToRemove = this.dataLoading.allFiles.map(function(key) { return key.name }).indexOf(file.name);
      this.dataLoading.allFiles.splice(idToRemove, 1)
      
      this.dataLoading.uploading = true
      this.dataLoading.file = file

      const payload = {
        key: null,
        title: file.name,
        content: file.content.trim(),
        lyricPictures: []
      }

      if(payload.content === 'undefined')
        payload.content = ''

      this.dataLoading.loadingName = file.name

      try {
        const bandLyricResource = await getBandLyricsService().createBandLyric(payload)
        const imageResource = await getBandLyricsService().createBandLyricPicture(bandLyricResource.data.id,
        file.image, 
        this.dataLoading.loadingOrder)

        if(imageResource === null)
          this.$root.showSnackbar("Błąd podczas przesyłania obrazka", "error")
      } catch(err) {
        
      }

      this.dataLoading.uploading = false;
      this.dataLoading.loadingOrder++
      if(this.dataLoading.allFiles.length > 0) {
        this.uploadSingleFile(this.dataLoading.allFiles[0])
      } else {
        this.currentlyImportingNumber--
        
        if(this.currentlyImportingNumber == 0) {
          this.dataLoading.updatedLoading = false
          this.dataLoading.loadingOrder = 0

          this.$root.showSnackbar("Pomyślnie dodano.", "success")

          if(!this.isAndroidContext) {
            this.$router.push({ name: 'lyrics-panel' })
          } else {
            this.importSuccess = true
          }
        }
      }
    },

    addToQueue(file) {
      this.dataLoading.allFiles.push(file)
      if(this.currentlyImportingNumber < 5) {
        this.uploadSingleFile(file, this.currentlyImportingNumber)
        this.currentlyImportingNumber++
      }
    },

    increaseMaxNumOfFiles(n) {
      this.dataLoading.numOfFiles += n
    },

    loadImage(src) {
      return new Promise(resolve => {
        let image = new Image()
        image.onload = (e) => {
          resolve(e.path[0])
        }
        image.src = src
      })
    },

    async mergeImages(files, name) {
      const canvas = document.createElement('canvas'),
            context = canvas.getContext('2d')
      let offsetY = 0,
          canvasHeight = 0

      files.forEach(element => {
        canvasHeight += element.length
      })
      for(let i = 0; i < files.length; i++) {
        let file = files[i]
        for(let j = 0; j < file.length; j++) {
          let image = await this.loadImage(file[j].image)
          if(i == 0 && j == 0) {
            canvas.width = image.width
            canvas.height = image.height * canvasHeight
          }

          context.drawImage(image, 0, 0, image.width, image.height, 0, offsetY, image.width, image.height)
          offsetY += image.height
        }
      }

      let content = ''
      files.forEach(f => {
        f.forEach((p, pI) => {
          if(pI == 0 && p.content) {
            let contentOnly = p.content.split('\n')
            contentOnly.splice(0, 1)
            p.content = contentOnly.join('\n')
          }
          content += p.content
          content += '\n'
        })
      })

      return {
        name: name || files[0][0].name,
        image: canvas.toDataURL('image/jpeg'),
        content: content
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.ImportWizard {
  min-height: 150px;
  margin: auto;
  background-color: rgb(0, 0, 0);

  &.android-context {
    .content {
      margin-top: 30px;
    }
  }

  .content {
    box-sizing: border-box;
    margin: 90px auto auto;
    min-height: calc(100vh - 358px);
    padding-bottom: 20px;
  }

  .header {
    h1 {
      color: #d6ae5d;
      border-bottom: 2px solid #fefefe;
      text-align: center;
      padding-bottom: 20px;
      margin-top: 0;
      margin-bottom: 30px;
      padding: 15px;

      @media screen and (max-width: $phone-max-width) {
        padding-top: 15px;
        margin-bottom: 20px;
      }
    }
  }

  @media screen and (max-width: $phone-max-width) {
    min-width: auto;
    .page-containers {
      overflow-x: hidden;
      display: flex;
      transition: margin-left .3s;
      margin: 0;
      align-items: flex-start;
      .page-container {
        min-width: 100vw;
        max-width: unset;
        border: none!important;
        &:not(.active) {
          transform: translateX(30%);
          .preview {
            transform: scale(.9);
            &:not(:first-child) {
              display: none;
            }
          }
        }
        &.active + .page-container {
          .preview {
            transform: scale(.9);
          }
          transform: translateX(-30%);
        }
        &.active {
          translate: transform .3s;
        }

        .preview {
          width: 60%!important;
          image-rendering: pixelated;
          margin-bottom: 1rem!important;
        }
      }
   }
  }

  .mobile-header {
    margin-bottom: 1rem;
    position: relative;
    .hidden-value {
      position: absolute;
      height: 0;
      overflow: hidden;
      white-space: pre;
    }
    text-align: center;
    .page-title {
      max-width: 75%;
      margin: auto;
      text-align: left;
    }
    .hidden-value, input {
      font: inherit;
      margin: 0;
      padding: 0;
    }
    .icon {
      margin-left: 4px;
      position: absolute;
      bottom: 1rem;
      right: calc(12.5% + 1rem);
    }
  }

  .mobile-bar {
    text-align: center;
    margin-top: 1rem;
    position: fixed;
    bottom: 2rem;
    width: 100%;
    left: 0;
    z-index: 2;
    .mobile-counter {
      padding: 8px 24px;
      background: gray;
      border: solid 1px #fff;
      border-radius: 24px;
    }
    .last-button {
      margin-top: 2rem!important;
      font-size: 1rem;
      padding: 12px 24px;
      background: #000;
    }
  }

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: $gold;
  }

  .page-containers {
    .page-container:not(:last-child) .page-container-content {
      border-bottom: solid 1px gray;
    }

    .page-container {
      max-width: 30%;
      margin: 0 auto;
      margin-bottom: 1rem;
      .header {
        padding: 8px;
        input {
          text-align: center;
          background: transparent;
          border: none;
          color: #fff;
          font-size: 16px;
          border-bottom: solid 2px transparent;
          width: 100%;
          &:focus {
            outline: none;
            border-bottom-color: #fff;
          }
        }
      }
      .preview {
        display: block;
        width: 144px;
        margin: auto;
        margin-bottom: .5rem;
        cursor: pointer;
      }
    }
  }

  .mobile-swiper {
    .swiper-slide {
      width: 75%;
      .single-page {
        position: relative;
        .icon.remove {
          position: absolute;
          right: 1rem;
          top: 1rem;
          color: $red;
          background: rgba(0, 0, 0, .5);
          width: 32px;
          height: 32px;
          font-size: 16px;
          border-radius: 50%;
        }
      }
    }
    .preview {
      width: 100%;
    }
  }

  .buttons {
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
    .cancel-button {
      margin-right: 2rem;
    }
  }

  .last-button {
    display: block;
    margin: auto;
  }

  
  .ph-item {
    direction: ltr;
    position: relative;
    /* width: 355px; */
    padding: 0;
    overflow: hidden;
    margin-bottom: 0;
    background-color: transparent;
    border: none;
    border-radius: none;
    flex-direction: column;

    &::before {
      display: none;
    }

    .ph-row {
      display: flex;
      justify-content: space-between;
      margin: 0;
      &.buttons {
        justify-content: center;
        margin-bottom: 2rem;
        flex-direction: row;
        .big {
          max-width: 100px;
          margin-bottom: 0;
          &:first-child {
            margin-right: 2rem;
          }
        }
      }
    }

    .ph-col-12 {
      margin: 0;
      padding: 0;
      &.pages {
        max-width: 30%;
        margin: auto;
        .ph-row {
          width: 30vw;
          margin-bottom: 12px;
          .image {
            margin: auto;
            width: 144px;
            height:  204px;
          }
        }
      }
    }

    .big {
      height: 22px;
      width: 100%;
      border-radius: 6px;
      position: relative;
      overflow: hidden;
      background-color: #727271;

      &::before {
        content: " ";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 50%;
        width: 500%;
        margin-left: -250%;
        -webkit-animation: phAnimation 0.8s linear infinite;
        animation: phAnimation 0.8s linear infinite;
        background: linear-gradient(
                to right,
                rgba(255, 255, 255, 0) 46%,
                rgba(255, 255, 255, 0.35) 50%,
                rgba(255, 255, 255, 0) 54%) 50% 50%;
        z-index: 0;
      }
    }

    .gold {
      background-color: #d6ae5d;
    }

    .first {
      width: 250px;
    }

    .second {
      width: 100px;
    }

    .ph-item > * {
      padding: 0;
    }
  }
}

.loader-wrapper {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-top: 12rem;
}

.loader {
  width: 20px;
  margin: 1px;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 0.5em solid $primary;
  border-right: 0.5em solid $primary;
  border-bottom: 0.5em solid $primary;
  border-left: 0.5em solid #ffffff;
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 0.8s infinite linear;
}

.loader,
.loader:after {
  border-radius: 100%;
  width: 3em;
  height: 3em;
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
